import { apiClient } from '../utils/api-client'
import type { WorkoutResult, CreateWorkoutResultPayload, WorkoutResultPayload } from '../types/workout'

interface WorkoutResultResponse {
  data: { id: string; type: string; attributes: WorkoutResult }
}

interface WorkoutResultsResponse {
  data: Array<{ id: string; type: string; attributes: WorkoutResult }>
}

interface ListOptions {
  from?: string
  to?: string
  exerciseId?: string
}

class WorkoutResultsService {
  async list(options: ListOptions = {}): Promise<WorkoutResult[]> {
    const params = new URLSearchParams()
    if (options.from) params.set('from', options.from)
    if (options.to) params.set('to', options.to)
    if (options.exerciseId) params.set('exercise_id', options.exerciseId)
    const query = params.toString() ? `?${params}` : ''
    const response = await apiClient.get(`/api/workout_results${query}`, { requireAuth: true })
    const json: WorkoutResultsResponse = await response.json()
    return json.data.map((d) => ({ ...d.attributes, id: d.id }))
  }

  async show(id: string): Promise<WorkoutResult> {
    const response = await apiClient.get(`/api/workout_results/${id}`, { requireAuth: true })
    const json: WorkoutResultResponse = await response.json()
    return { ...json.data.attributes, id: json.data.id }
  }

  async create(payload: CreateWorkoutResultPayload): Promise<WorkoutResult> {
    const response = await apiClient.post('/api/workout_results', {
      data: { attributes: payload },
    }, { requireAuth: true })
    const json: WorkoutResultResponse = await response.json()
    return { ...json.data.attributes, id: json.data.id }
  }

  async update(id: string, payload: Partial<WorkoutResultPayload>): Promise<WorkoutResult> {
    const response = await apiClient.patch(`/api/workout_results/${id}`, {
      data: { attributes: payload },
    }, { requireAuth: true })
    const json: WorkoutResultResponse = await response.json()
    return { ...json.data.attributes, id: json.data.id }
  }

  async destroy(id: string): Promise<void> {
    await apiClient.delete(`/api/workout_results/${id}`, { requireAuth: true })
  }
}

export const workoutResultsService = new WorkoutResultsService()
